import { pushToDataLayer } from '@repo/shared/shared';
import { PricingWidgetForm } from '@repo/shared/widgets';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { ITariffPlan } from '@/entities/payment';
import { config } from '@/shared/constants';
import { useGlobalState } from '@/shared/providers';

export interface IPricingWidgetProps {
  tariffs: ITariffPlan[];
}

const PricingWidget: FC<IPricingWidgetProps> = ({ tariffs }) => {
  const router = useRouter();
  const { quizResult } = useGlobalState();

  const signUpUrl = `${config.reviewsAppUrl}/signup${quizResult ? `?quiz=${quizResult}` : ''}`;
  const smsPlan = tariffs?.find(({ type }) => type === 'SMS');

  const subscriptionPlans = tariffs
    ?.map((subscription) => {
      if (subscription.type === 'SUBSCRIPTION') {
        return subscription;
      }
    })
    .filter(Boolean)
    .sort((a, b) => a!.activeUsers - b!.activeUsers);

  const onSubmit = () => {
    pushToDataLayer('click_on_subscribe_plan', { from: 'landing' });
    router.push(signUpUrl);
  };

  return (
    <PricingWidgetForm
      mt='2xl'
      smsPlan={smsPlan!}
      subscribeButtonProps={{ type: 'button', onClick: onSubmit }}
      subscribeButtonText='Start free trial'
      subscriptionPlans={subscriptionPlans as [ITariffPlan]}
    />
  );
};

export default PricingWidget;
